'use strict';

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr && (typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]); if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, '__esModule', {
  value: true
});

var motionDom = require('motion-dom');

var motionUtils = require('motion-utils');

function isDOMKeyframes(keyframes) {
  return _typeof(keyframes) === "object" && !Array.isArray(keyframes);
}

function resolveSubjects(subject, keyframes, scope, selectorCache) {
  if (typeof subject === "string" && isDOMKeyframes(keyframes)) {
    return motionDom.resolveElements(subject, scope, selectorCache);
  } else if (subject instanceof NodeList) {
    return Array.from(subject);
  } else if (Array.isArray(subject)) {
    return subject;
  } else {
    return [subject];
  }
}

function calculateRepeatDuration(duration, repeat, _repeatDelay) {
  return duration * (repeat + 1);
}
/**
 * Given a absolute or relative time definition and current/prev time state of the sequence,
 * calculate an absolute time for the next keyframes.
 */


function calcNextTime(current, next, prev, labels) {
  if (typeof next === "number") {
    return next;
  } else if (next.startsWith("-") || next.startsWith("+")) {
    return Math.max(0, current + parseFloat(next));
  } else if (next === "<") {
    return prev;
  } else if (next.startsWith("<")) {
    return Math.max(0, prev + parseFloat(next.slice(1)));
  } else {
    var _labels$get;

    return (_labels$get = labels.get(next)) !== null && _labels$get !== void 0 ? _labels$get : current;
  }
}

function eraseKeyframes(sequence, startTime, endTime) {
  for (var i = 0; i < sequence.length; i++) {
    var keyframe = sequence[i];

    if (keyframe.at > startTime && keyframe.at < endTime) {
      motionUtils.removeItem(sequence, keyframe); // If we remove this item we have to push the pointer back one

      i--;
    }
  }
}

function addKeyframes(sequence, keyframes, easing, offset, startTime, endTime) {
  /**
   * Erase every existing value between currentTime and targetTime,
   * this will essentially splice this timeline into any currently
   * defined ones.
   */
  eraseKeyframes(sequence, startTime, endTime);

  for (var i = 0; i < keyframes.length; i++) {
    sequence.push({
      value: keyframes[i],
      at: motionDom.mixNumber(startTime, endTime, offset[i]),
      easing: motionUtils.getEasingForSegment(easing, i)
    });
  }
}
/**
 * Take an array of times that represent repeated keyframes. For instance
 * if we have original times of [0, 0.5, 1] then our repeated times will
 * be [0, 0.5, 1, 1, 1.5, 2]. Loop over the times and scale them back
 * down to a 0-1 scale.
 */


function normalizeTimes(times, repeat) {
  for (var i = 0; i < times.length; i++) {
    times[i] = times[i] / (repeat + 1);
  }
}

function compareByTime(a, b) {
  if (a.at === b.at) {
    if (a.value === null) return 1;
    if (b.value === null) return -1;
    return 0;
  } else {
    return a.at - b.at;
  }
}

var defaultSegmentEasing = "easeInOut";
var MAX_REPEAT = 20;

function createAnimationsFromSequence(sequence) {
  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      _ref$defaultTransitio = _ref.defaultTransition,
      defaultTransition = _ref$defaultTransitio === void 0 ? {} : _ref$defaultTransitio,
      sequenceTransition = _objectWithoutProperties(_ref, ["defaultTransition"]);

  var scope = arguments.length > 2 ? arguments[2] : undefined;
  var generators = arguments.length > 3 ? arguments[3] : undefined;
  var defaultDuration = defaultTransition.duration || 0.3;
  var animationDefinitions = new Map();
  var sequences = new Map();
  var elementCache = {};
  var timeLabels = new Map();
  var prevTime = 0;
  var currentTime = 0;
  var totalDuration = 0;
  /**
   * Build the timeline by mapping over the sequence array and converting
   * the definitions into keyframes and offsets with absolute time values.
   * These will later get converted into relative offsets in a second pass.
   */

  var _loop = function _loop(i) {
    var segment = sequence[i];
    /**
     * If this is a timeline label, mark it and skip the rest of this iteration.
     */

    if (typeof segment === "string") {
      timeLabels.set(segment, currentTime);
      return "continue";
    } else if (!Array.isArray(segment)) {
      timeLabels.set(segment.name, calcNextTime(currentTime, segment.at, prevTime, timeLabels));
      return "continue";
    }

    var _segment = _slicedToArray(segment, 3),
        subject = _segment[0],
        keyframes = _segment[1],
        _segment$ = _segment[2],
        transition = _segment$ === void 0 ? {} : _segment$;
    /**
     * If a relative or absolute time value has been specified we need to resolve
     * it in relation to the currentTime.
     */


    if (transition.at !== undefined) {
      currentTime = calcNextTime(currentTime, transition.at, prevTime, timeLabels);
    }
    /**
     * Keep track of the maximum duration in this definition. This will be
     * applied to currentTime once the definition has been parsed.
     */


    var maxDuration = 0;

    var resolveValueSequence = function resolveValueSequence(valueKeyframes, valueTransition, valueSequence) {
      var _duration;

      var elementIndex = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
      var numSubjects = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 0;
      var valueKeyframesAsList = keyframesAsList(valueKeyframes);

      var _valueTransition$dela = valueTransition.delay,
          delay = _valueTransition$dela === void 0 ? 0 : _valueTransition$dela,
          _valueTransition$time = valueTransition.times,
          times = _valueTransition$time === void 0 ? motionDom.defaultOffset(valueKeyframesAsList) : _valueTransition$time,
          _valueTransition$type = valueTransition.type,
          type = _valueTransition$type === void 0 ? "keyframes" : _valueTransition$type,
          repeat = valueTransition.repeat,
          repeatType = valueTransition.repeatType,
          _valueTransition$repe = valueTransition.repeatDelay,
          repeatDelay = _valueTransition$repe === void 0 ? 0 : _valueTransition$repe,
          remainingTransition = _objectWithoutProperties(valueTransition, ["delay", "times", "type", "repeat", "repeatType", "repeatDelay"]);

      var _valueTransition$ease = valueTransition.ease,
          ease = _valueTransition$ease === void 0 ? defaultTransition.ease || "easeOut" : _valueTransition$ease,
          duration = valueTransition.duration;
      /**
       * Resolve stagger() if defined.
       */

      var calculatedDelay = typeof delay === "function" ? delay(elementIndex, numSubjects) : delay;
      /**
       * If this animation should and can use a spring, generate a spring easing function.
       */

      var numKeyframes = valueKeyframesAsList.length;
      var createGenerator = motionDom.isGenerator(type) ? type : generators === null || generators === void 0 ? void 0 : generators[type || "keyframes"];

      if (numKeyframes <= 2 && createGenerator) {
        /**
         * As we're creating an easing function from a spring,
         * ideally we want to generate it using the real distance
         * between the two keyframes. However this isn't always
         * possible - in these situations we use 0-100.
         */
        var absoluteDelta = 100;

        if (numKeyframes === 2 && isNumberKeyframesArray(valueKeyframesAsList)) {
          var delta = valueKeyframesAsList[1] - valueKeyframesAsList[0];
          absoluteDelta = Math.abs(delta);
        }

        var springTransition = _objectSpread({}, remainingTransition);

        if (duration !== undefined) {
          springTransition.duration = motionUtils.secondsToMilliseconds(duration);
        }

        var springEasing = motionDom.createGeneratorEasing(springTransition, absoluteDelta, createGenerator);
        ease = springEasing.ease;
        duration = springEasing.duration;
      }

      (_duration = duration) !== null && _duration !== void 0 ? _duration : duration = defaultDuration;
      var startTime = currentTime + calculatedDelay;
      /**
       * If there's only one time offset of 0, fill in a second with length 1
       */

      if (times.length === 1 && times[0] === 0) {
        times[1] = 1;
      }
      /**
       * Fill out if offset if fewer offsets than keyframes
       */


      var remainder = times.length - valueKeyframesAsList.length;
      remainder > 0 && motionDom.fillOffset(times, remainder);
      /**
       * If only one value has been set, ie [1], push a null to the start of
       * the keyframe array. This will let us mark a keyframe at this point
       * that will later be hydrated with the previous value.
       */

      valueKeyframesAsList.length === 1 && valueKeyframesAsList.unshift(null);
      /**
       * Handle repeat options
       */

      if (repeat) {
        motionUtils.invariant(repeat < MAX_REPEAT, "Repeat count too high, must be less than 20");
        duration = calculateRepeatDuration(duration, repeat);

        var originalKeyframes = _toConsumableArray(valueKeyframesAsList);

        var originalTimes = _toConsumableArray(times);

        ease = Array.isArray(ease) ? _toConsumableArray(ease) : [ease];

        var originalEase = _toConsumableArray(ease);

        for (var repeatIndex = 0; repeatIndex < repeat; repeatIndex++) {
          valueKeyframesAsList.push.apply(valueKeyframesAsList, _toConsumableArray(originalKeyframes));

          for (var keyframeIndex = 0; keyframeIndex < originalKeyframes.length; keyframeIndex++) {
            times.push(originalTimes[keyframeIndex] + (repeatIndex + 1));
            ease.push(keyframeIndex === 0 ? "linear" : motionUtils.getEasingForSegment(originalEase, keyframeIndex - 1));
          }
        }

        normalizeTimes(times, repeat);
      }

      var targetTime = startTime + duration;
      /**
       * Add keyframes, mapping offsets to absolute time.
       */

      addKeyframes(valueSequence, valueKeyframesAsList, ease, times, startTime, targetTime);
      maxDuration = Math.max(calculatedDelay + duration, maxDuration);
      totalDuration = Math.max(targetTime, totalDuration);
    };

    if (motionDom.isMotionValue(subject)) {
      var subjectSequence = getSubjectSequence(subject, sequences);
      resolveValueSequence(keyframes, transition, getValueSequence("default", subjectSequence));
    } else {
      var subjects = resolveSubjects(subject, keyframes, scope, elementCache);
      var numSubjects = subjects.length;
      /**
       * For every element in this segment, process the defined values.
       */

      for (var subjectIndex = 0; subjectIndex < numSubjects; subjectIndex++) {
        /**
         * Cast necessary, but we know these are of this type
         */
        keyframes = keyframes;
        transition = transition;
        var thisSubject = subjects[subjectIndex];

        var _subjectSequence = getSubjectSequence(thisSubject, sequences);

        for (var key in keyframes) {
          resolveValueSequence(keyframes[key], getValueTransition(transition, key), getValueSequence(key, _subjectSequence), subjectIndex, numSubjects);
        }
      }
    }

    prevTime = currentTime;
    currentTime += maxDuration;
  };

  for (var i = 0; i < sequence.length; i++) {
    var _ret = _loop(i);

    if (_ret === "continue") continue;
  }
  /**
   * For every element and value combination create a new animation.
   */


  sequences.forEach(function (valueSequences, element) {
    for (var key in valueSequences) {
      var valueSequence = valueSequences[key];
      /**
       * Arrange all the keyframes in ascending time order.
       */

      valueSequence.sort(compareByTime);
      var keyframes = [];
      var valueOffset = [];
      var valueEasing = [];
      /**
       * For each keyframe, translate absolute times into
       * relative offsets based on the total duration of the timeline.
       */

      for (var _i = 0; _i < valueSequence.length; _i++) {
        var _valueSequence$_i = valueSequence[_i],
            at = _valueSequence$_i.at,
            value = _valueSequence$_i.value,
            easing = _valueSequence$_i.easing;
        keyframes.push(value);
        valueOffset.push(motionUtils.progress(0, totalDuration, at));
        valueEasing.push(easing || "easeOut");
      }
      /**
       * If the first keyframe doesn't land on offset: 0
       * provide one by duplicating the initial keyframe. This ensures
       * it snaps to the first keyframe when the animation starts.
       */


      if (valueOffset[0] !== 0) {
        valueOffset.unshift(0);
        keyframes.unshift(keyframes[0]);
        valueEasing.unshift(defaultSegmentEasing);
      }
      /**
       * If the last keyframe doesn't land on offset: 1
       * provide one with a null wildcard value. This will ensure it
       * stays static until the end of the animation.
       */


      if (valueOffset[valueOffset.length - 1] !== 1) {
        valueOffset.push(1);
        keyframes.push(null);
      }

      if (!animationDefinitions.has(element)) {
        animationDefinitions.set(element, {
          keyframes: {},
          transition: {}
        });
      }

      var definition = animationDefinitions.get(element);
      definition.keyframes[key] = keyframes;
      definition.transition[key] = _objectSpread(_objectSpread({}, defaultTransition), {}, {
        duration: totalDuration,
        ease: valueEasing,
        times: valueOffset
      }, sequenceTransition);
    }
  });
  return animationDefinitions;
}

function getSubjectSequence(subject, sequences) {
  !sequences.has(subject) && sequences.set(subject, {});
  return sequences.get(subject);
}

function getValueSequence(name, sequences) {
  if (!sequences[name]) sequences[name] = [];
  return sequences[name];
}

function keyframesAsList(keyframes) {
  return Array.isArray(keyframes) ? keyframes : [keyframes];
}

function getValueTransition(transition, key) {
  return transition && transition[key] ? _objectSpread(_objectSpread({}, transition), transition[key]) : _objectSpread({}, transition);
}

var isNumber = function isNumber(keyframe) {
  return typeof keyframe === "number";
};

var isNumberKeyframesArray = function isNumberKeyframesArray(keyframes) {
  return keyframes.every(isNumber);
};

function animateElements(elementOrSelector, keyframes, options, scope) {
  var elements = motionDom.resolveElements(elementOrSelector, scope);
  var numElements = elements.length;
  motionUtils.invariant(Boolean(numElements), "No valid element provided.");
  /**
   * WAAPI doesn't support interrupting animations.
   *
   * Therefore, starting animations requires a three-step process:
   * 1. Stop existing animations (write styles to DOM)
   * 2. Resolve keyframes (read styles from DOM)
   * 3. Create new animations (write styles to DOM)
   *
   * The hybrid `animate()` function uses AsyncAnimation to resolve
   * keyframes before creating new animations, which removes style
   * thrashing. Here, we have much stricter filesize constraints.
   * Therefore we do this in a synchronous way that ensures that
   * at least within `animate()` calls there is no style thrashing.
   *
   * In the motion-native-animate-mini-interrupt benchmark this
   * was 80% faster than a single loop.
   */

  var animationDefinitions = [];
  /**
   * Step 1: Build options and stop existing animations (write)
   */

  for (var i = 0; i < numElements; i++) {
    var element = elements[i];

    var elementTransition = _objectSpread({}, options);
    /**
     * Resolve stagger function if provided.
     */


    if (typeof elementTransition.delay === "function") {
      elementTransition.delay = elementTransition.delay(i, numElements);
    }

    for (var valueName in keyframes) {
      var valueKeyframes = keyframes[valueName];

      if (!Array.isArray(valueKeyframes)) {
        valueKeyframes = [valueKeyframes];
      }

      var valueOptions = _objectSpread({}, motionDom.getValueTransition(elementTransition, valueName));

      valueOptions.duration && (valueOptions.duration = motionUtils.secondsToMilliseconds(valueOptions.duration));
      valueOptions.delay && (valueOptions.delay = motionUtils.secondsToMilliseconds(valueOptions.delay));
      /**
       * If there's an existing animation playing on this element then stop it
       * before creating a new one.
       */

      var map = motionDom.getAnimationMap(element);
      var key = motionDom.animationMapKey(valueName, valueOptions.pseudoElement || "");
      var currentAnimation = map.get(key);
      currentAnimation && currentAnimation.stop();
      animationDefinitions.push({
        map: map,
        key: key,
        unresolvedKeyframes: valueKeyframes,
        options: _objectSpread(_objectSpread({}, valueOptions), {}, {
          element: element,
          name: valueName,
          allowFlatten: !elementTransition.type && !elementTransition.ease
        })
      });
    }
  }
  /**
   * Step 2: Resolve keyframes (read)
   */


  for (var _i2 = 0; _i2 < animationDefinitions.length; _i2++) {
    var _animationDefinitions = animationDefinitions[_i2],
        unresolvedKeyframes = _animationDefinitions.unresolvedKeyframes,
        animationOptions = _animationDefinitions.options;
    var _element = animationOptions.element,
        name = animationOptions.name,
        pseudoElement = animationOptions.pseudoElement;

    if (!pseudoElement && unresolvedKeyframes[0] === null) {
      unresolvedKeyframes[0] = motionDom.getComputedStyle(_element, name);
    }

    motionDom.fillWildcards(unresolvedKeyframes);
    motionDom.applyPxDefaults(unresolvedKeyframes, name);
    /**
     * If we only have one keyframe, explicitly read the initial keyframe
     * from the computed style. This is to ensure consistency with WAAPI behaviour
     * for restarting animations, for instance .play() after finish, when it
     * has one vs two keyframes.
     */

    if (!pseudoElement && unresolvedKeyframes.length < 2) {
      unresolvedKeyframes.unshift(motionDom.getComputedStyle(_element, name));
    }

    animationOptions.keyframes = unresolvedKeyframes;
  }
  /**
   * Step 3: Create new animations (write)
   */


  var animations = [];

  var _loop2 = function _loop2(_i3) {
    var _animationDefinitions2 = animationDefinitions[_i3],
        map = _animationDefinitions2.map,
        key = _animationDefinitions2.key,
        animationOptions = _animationDefinitions2.options;
    var animation = new motionDom.NativeAnimation(animationOptions);
    map.set(key, animation);
    animation.finished.finally(function () {
      return map.delete(key);
    });
    animations.push(animation);
  };

  for (var _i3 = 0; _i3 < animationDefinitions.length; _i3++) {
    _loop2(_i3);
  }

  return animations;
}

function animateSequence(definition, options) {
  var animations = [];
  createAnimationsFromSequence(definition, options).forEach(function (_ref2, element) {
    var keyframes = _ref2.keyframes,
        transition = _ref2.transition;
    animations.push.apply(animations, _toConsumableArray(animateElements(element, keyframes, transition)));
  });
  return new motionDom.GroupAnimationWithThen(animations);
}

var createScopedWaapiAnimate = function createScopedWaapiAnimate(scope) {
  function scopedAnimate(elementOrSelector, keyframes, options) {
    return new motionDom.GroupAnimationWithThen(animateElements(elementOrSelector, keyframes, options, scope));
  }

  return scopedAnimate;
};

var animateMini = /*@__PURE__*/createScopedWaapiAnimate();
exports.animate = animateMini;
exports.animateSequence = animateSequence;